// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../provider/Context.bs.js";
import * as Type_Url from "../type/Type_Url.bs.js";
import * as Util_Url from "../util/Util_Url.bs.js";
import * as User_Type from "../user/User_Type.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_String from "../type/Type_String.bs.js";
import * as User_Provider from "../user/User_Provider.bs.js";

function setUidParamForAnonymous(token, url) {
  var token$1 = Belt_Option.map(Belt_Option.flatMap(token, Type_String.User.Token.getAnonymousToken), Type_String.User.Token.anonymousToString);
  if (token$1 !== undefined) {
    return Util_Url.setQueryParam(url, "uid", token$1);
  } else {
    return url;
  }
}

function make(trackingPixel) {
  var match = Context.Config.getState(undefined);
  var trackPixel = match.trackPixel;
  var token = Curry._1(User_Provider.Hook.useToken, undefined);
  var userStatus = Curry._1(User_Provider.Hook.useUserStatus, undefined);
  var setUidParam = React.useCallback((function (param) {
          return setUidParamForAnonymous(token, param);
        }), [token]);
  return function (param) {
    if (!(trackPixel == null) && trackingPixel !== undefined) {
      return Curry._1(trackPixel, Type_Url.TrackingPixel.toEncodedString(Curry._1(setUidParam, Util_Url.setQueryParam(Caml_option.valFromOption(trackingPixel), "user", User_Type.Status.toString(userStatus)))));
    }
    
  };
}

export {
  setUidParamForAnonymous ,
  make ,
}
/* react Not a pure module */
